import React, { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';
import { signInWithGoogle } from './firebase';
import { FaSpinner } from 'react-icons/fa'; // Import spinner icon

function Register() {
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Error signing in with Google", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div
          className="d-none d-md-block col-md-6 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: '#f8f9fa',
            height: '100vh',
            backgroundImage: 'url(https://files.designbanner.co/banner-for-any-needs.png)',
            backgroundSize: 'contain',
            backgroundPosition: 'center'
          }}
        >
        </div>

        <div
          className="col-12 col-md-6 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: '#ffffff', height: '100vh' }}
        >
          <div className="d-flex flex-column align-items-center">
            <img src="https://files.designbanner.co/banner-design-ai-logo-2.png" alt="ArtWand" className="img-fluid" style={{ width: '50%' }} />
            <h4 className='pt-0 mt-0'>Best AI banner maker for your needs.</h4>
            <button onClick={handleSignIn} className="mt-5 btn brand-button-outline fs-5 d-flex align-items-center mb-3" disabled={loading}>
              {loading ? (
                <>
                  <FaSpinner className="me-2 spinner" /> Loading...
                </>
              ) : (
                <>
                  <FcGoogle className='me-2 display-6' /> Continue with Google
                </>
              )}
            </button>
            <span>Trusted by 500+ users around the world!</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;